import React from "react";

const HorizontalRule = () => 
    <hr style={{ backgroundColor: '#D9D9D9', border: 'none', height: '2px', width: '100%' }} />

export default HorizontalRule;
